import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IErrorLog } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/logsError';

interface ISearchRequest {
  offset: number;
  limit: number;
  keyword: string;
  dateFrom: string;
  dateTo: string;
}

interface ISearchResult {
  items: IErrorLog[];
  count: number;
}

export default {
  get(req: ISearchRequest, success: (res: ISearchResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<ISearchResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
